import * as yup from 'yup'
import {
  emailRgx,
  emailvalidMessage,
  passwordRegx,
  passwordNotAllow,
  upperCase,
  lowerCase,
  contactRegx,
  blankRegx,
  digitRegx,
  strikeRegx,
  OnlyAlphabet,
  NameRegx,
  isValidDecimal,
  propertyNameRegx,
  digitIsRegx,
  regionNameRegx,
  startWithCapital,
  invalidTimeFormat,
  couponRegx,
  couponCodeRegx,
  subjectRegx,
  subjectStartRegx,
  clientNameRegx,
  NameOnlyContainLetterRegx,
  describeIssueRegx,
  categoryRegx,
  pricingNameRegx,
  serviceNameRegx
} from './patterns/pattern'

export const registerFormschema = yup
  .object({
    first_name: yup
      .string()
      .required('First name is required.')
      .min(2, 'First name must be at least 2 characters long.')
      .max(50, `First name must not be more than 50 characters.`)
      .test('noNumbers', 'First name must not contain any numbers.', (value) => !digitRegx.test(value))
      .matches(NameRegx, 'First name can only contain letters without leading or trailing spaces.'),
    last_name: yup
      .string()
      .required('Last name is required.')
      .min(2, 'Last name must be at least 2 characters long.')
      .max(50, `Last name must not be more than 50 characters.`)
      .test('noNumbers', 'Last name must not contain any numbers.', (value) => !digitRegx.test(value))
      .matches(NameRegx, 'Last name can only contain letters without leading or trailing spaces.'),
    email: yup.string().required('Email address is required.').email(emailvalidMessage).matches(emailRgx, emailvalidMessage).max(64).trim(),
    contact_no: yup
      .string()
      .required('Contact number is required.')
      .matches(contactRegx, 'Contact number must be in the format (xxx) xxx-xxxx.')
      .min(10, 'Contact number must be at least 10 digits.')
      .max(15, 'Contact number must be at most 15 digits.'),
    password: yup
      .string()
      .required('Password is required.')
      .matches(blankRegx, 'Password must not contain blank spaces.') // No spaces allowed
      .matches(upperCase, 'Password must contain at least one uppercase letter.')
      .matches(lowerCase, 'Password must contain at least one lowercase letter.')
      .matches(digitRegx, 'Password must contain at least one number.')
      .matches(passwordNotAllow, "Password must not contain the (`or') symbol.")
      .matches(passwordRegx, 'Password must contain at least one special character.')
      .min(6, 'Password must be at least 6 characters long.')
      .trim(),
    confirmPassword: yup
      .string()
      .required('Confirm password is required.')
      .oneOf([yup.ref('password'), null], 'Passwords must match.')
    // personal_address: yup.string().required('Address is required').min(10, 'Address must be at least 10 characters')
  })
  .required()

export const loginFormScheme = yup.object({
  email: yup.string().required('Email address is required.').email(emailvalidMessage).matches(emailRgx, emailvalidMessage).max(64).trim(),
  password: yup
    .string()
    .required('Password is required.')
    .matches(blankRegx, 'Password must not contain blank spaces.') // No spaces allowed
    .matches(upperCase, 'Password must contain at least one uppercase letter.')
    .matches(lowerCase, 'Password must contain at least one lowercase letter.')
    .matches(digitRegx, 'Password must contain at least one number.')
    .matches(passwordNotAllow, "Password must not contain the (`or') symbol.")
    .matches(passwordRegx, 'Password must contain at least one special character.')
    .min(6, 'Password must be at least 6 characters long.')
    .trim()
})

export const forgotPasswordSchema = yup.object({
  email: yup.string().required('Email address is required.').email(emailvalidMessage).matches(emailRgx, emailvalidMessage).max(64).trim(),
})  

export const changePasswordSchema = yup.object().shape({
  currentPassword: yup.string().required('Current password is required.'),
  newPassword: yup
    .string()
    .required('New password is required.')
    .matches(blankRegx, 'New password must not contain blank spaces.') // No spaces allowed
    .matches(upperCase, 'New password must contain at least one uppercase letter.')
    .matches(lowerCase, 'New password must contain at least one lowercase letter.')
    .matches(digitRegx, 'New password must contain at least one number.')
    .matches(passwordNotAllow, "New password must not contain the (`or') symbol.")
    .matches(passwordRegx, 'New password must contain at least one special character.')
    .min(6, 'New password must be at least 6 characters long.')
    .trim(),
  confirmNewPassword: yup
    .string()
    .required('Confirm password is required.')
    .oneOf([yup.ref('newPassword'), null], 'Passwords must match.')
})

export const resetPasswordSchema = yup.object().shape({
  password: yup
    .string()
    .required('Password is required.')
    .matches(blankRegx, 'Password must not contain blank spaces.') // No spaces allowed
    .matches(upperCase, 'Password must contain at least one uppercase letter.')
    .matches(lowerCase, 'Password must contain at least one lowercase letter.')
    .matches(digitRegx, 'Password must contain at least one number.')
    .matches(passwordNotAllow, "Password must not contain the (`or') symbol.")
    .matches(passwordRegx, 'Password must contain at least one special character.')
    .min(6, 'Password must be at least 6 characters long.')
    .trim(),
  confirmPassword: yup
    .string()
    .required('Confirm password is required.')
    .oneOf([yup.ref('password')], 'Password does not match.')
})

export const adminControlSchema = yup.object().shape({
  first_name: yup
    .string()
    .required('First name is required.')
    .min(2, 'First name must be at least 2 characters.')
    .max(50, 'First name must not be more than 50 characters.')
    .test('noNumbers', 'First name should not contain numbers.', (value) => !digitRegx.test(value))
    .matches(NameRegx, 'First name can only contain letters without leading or trailing spaces.'),
  last_name: yup
    .string()
    .required('Last name is required.')
    .min(2, 'Last name must be at least 2 characters long.')
    .max(50, 'Last name must not be more than 50 characters.')
    .test('noNumbers', 'Last name should not contain numbers.', (value) => !digitRegx.test(value))
    .matches(NameRegx, 'Last name can only contain letters without leading or trailing spaces.'),
    email: yup.string().required('Email address is required.').email(emailvalidMessage).matches(emailRgx, emailvalidMessage).max(64).trim(),
  password: yup.string().when('is_change_password', {
    is: true,
    then: () =>
      yup
        .string()
        .required('Password is required.')
        .matches(blankRegx, 'Password must not contain blank spaces.') // No spaces allowed
        .matches(upperCase, 'Password must contain at least one uppercase letter.')
        .matches(lowerCase, 'Password must contain at least one lowercase letter.')
        .matches(digitRegx, 'Password must contain at least one number.')
        .matches(passwordNotAllow, "Password must not contain the (`or') symbol.")
        .matches(passwordRegx, 'Password must contain at least one special character.')
        .min(6, 'Password must be at least 6 characters long.')
        .trim(),
    otherwise: () => yup.string().notRequired()
  }),
  confirmPassword: yup.string().when('is_change_password', {
    is: true,
    then: () =>
      yup
        .string()
        .required('Confirm password is required.')
        .oneOf([yup.ref('password'), null], 'Passwords must match.'),
    otherwise: () => yup.string().notRequired()
  }),

  // region_id: yup
  //   .object()
  //   .required('Region is required')
  //   .shape({
  //     region_id: yup.string().required('Region is required'),
  //     region: yup.string().required()
  //   }),

  admin_type: yup
    .object()
    .required('Admin type is required.')
    .shape({
      value: yup.string().required('Admin type is required.'),
      key: yup.string().required()
    }),
  regions: yup.array().when('admin_type', {
    is: (adminType) => !adminType || adminType.value !== 'admin',
    then: () => yup.array().required('Regions are required.').min(1, 'At least one region must be selected.'),
    otherwise: () => yup.array().nullable().notRequired()
  }),
  contact_no: yup
    .string()
    .nullable()
    .notRequired()
    .test('is-valid-phone', 'Phone number must be in the format (xxx) xxx-xxxx.', (value) => {
      if (!value) return true
      return contactRegx.test(value)
    }),
  personal_address: yup.string().optional().max(255, 'Address must not be more than 255 characters.')
  // profile_image: yup
  //   .mixed()
  //   .optional()
  //   .test('fileSize', 'File size too large', (value) => !value || value.size <= 2000000) // example: 2MB
  //   .test('fileType', 'Unsupported file format', (value) => !value || ['image/jpg', 'image/jpeg', 'image/png'].includes(value.type))
})

export const clientsSchema = yup.object({
  first_name: yup
    .string()
    .required('First name is required.')
    .min(2, 'First name must be at least 2 characters long.')
    .max(50, 'First name must not be more than 50 characters.')
    .test('noNumbers', 'First name should not contain numbers.', (value) => !digitRegx.test(value))
    .matches(NameRegx, 'First name can only contain letters without leading or trailing spaces.'),
  last_name: yup
    .string()
    .required('Last name is required.')
    .min(2, 'Last name must be at least 2 characters long.')
    .max(50, 'Last name must not be more than 50 characters.')
    .test('noNumbers', 'Last name should not contain numbers.', (value) => !digitRegx.test(value))
    .matches(NameRegx, 'Last name can only contain letters without leading or trailing spaces.')
})

export const cleanerSchema = yup.object().shape({
  first_name: yup
    .string()
    .required('First name is required.')
    .min(2, 'First name must be at least 2 characters long.')
    .max(50, 'First name must not be more than 50 characters.')
    .test('noNumbers', 'First name should not contain numbers.', (value) => !digitRegx.test(value))
    .matches(NameRegx, 'First name can only contain letters without leading or trailing spaces.'),
  last_name: yup
    .string()
    .required('Last name is required.')
    .min(2, 'Last name must be at least 2 characters long.')
    .max(50, 'Last name must not be more than 50 characters.')
    .test('noNumbers', 'Last name should not contain numbers.', (value) => !digitRegx.test(value))
    .matches(NameRegx, 'Last name can only contain letters without leading or trailing spaces.'),
  phone_number: yup
    .string()
    .test('is-valid-phone', 'Phone number must be in the format (xxx) xxx-xxxx.', (value) => {
      if (!value) return false
      const format2 = /^\d{10}$/
      return contactRegx.test(value) || format2.test(value)
    })
    .required('Phone number is required.')
})

export const strikeSchema = yup.object().shape({
  reason: yup
    .string()
    .required('Reason is required.')
    .min(5, 'Reason must be at least 5 characters long.')
    .max(255, 'Reason must be at most 255 characters long.')
    .matches(strikeRegx, 'Reason must be alphabetic or alphanumeric, but cannot consist of only numbers.')
})

export const addNotesSchema = yup.object().shape({
  description: yup
    .string()
    .required('Description is required.')
    .min(5, 'Description must be at least 5 characters long.')
    .max(255, 'Description must be at most 255 characters long.')
})

export const scheduleCleningSchema = yup.object().shape({
  booking_date_time: yup.string().when('cleaning_on', {
    is: (cleaning_on) => cleaning_on === 'Cleaning on checkout', // Conditional validation
    then: () => yup.string().required('Booking date and time is required.'),
    otherwise: () => yup.string() // Optional if cleaning_on is not "Cleaning on checkout"
  }),

  // next_checkin_time validation
  next_checkin_time: yup.string().when('cleaning_on', {
    is: () => true,
    then: () =>
      yup
        .string()
        .nullable()
        .test('checkInAfterBooking', 'Check-in date must be after booking date.', function (checkInDate) {
          const { booking_date_time } = this.parent
          if (!checkInDate || !booking_date_time) return true
          const checkIn = new Date(checkInDate)
          const booking = new Date(booking_date_time)
          return checkIn > booking
        }),
    otherwise: () => yup.string() // Optional if cleaning_on is not "Cleaning on check-in"
  })
})

export const scheduleSchema = yup.object().shape({
  date: yup.date().required('Date is required.').typeError('Invalid date format.'),
  time: yup.string().required('Time is required').matches(invalidTimeFormat, 'Invalid time format.'),
  next_checkin_date: yup.date().required('Next checkin date is required.').typeError('Invalid date format.'),
  next_checkin_time: yup.string().required('Next checkin time is required.').matches(invalidTimeFormat, 'Invalid time format.')
})

export const addiCalSchema = yup.object().shape({
  propertyICalLink: yup.array().of(
    yup.object().shape({
      ical_label: yup.string().required('ICal label is required.'),
      ical_link: yup.string().url('ICal link must be a valid URL.').required('ICal link is required.')
    })
  )
  // cleaning_on: yup.string().optional().required('Cleaning option is required')
})

export const propertySchema = yup.object().shape({
  property_name: yup
    .string()
    // .trim()
    .required('Property name is required.')
    .matches(
      propertyNameRegx,
      "Property name can only contain letters, numbers, spaces, and the symbols /\\.@-_,`’'&* without leading or trailing spaces."
    )
    .min(2, 'Property name must be at least 2 characters long.')
    .max(50, 'Property name must not be more than 50 characters.'),
  address: yup.string().trim().required('Address is required.'),
  state: yup.string().trim().required('State is required.').matches(OnlyAlphabet, 'State must contain only letters.'),
  city: yup.string().trim().required('City is required.').matches(OnlyAlphabet, 'City must contain only letters.'),
  zipcode: yup
    .string()
    .trim()
    .required('Zipcode is required.')
    .matches(digitIsRegx, 'Zipcode must be digits.')
    .typeError('Only digits are allowed.')
    .min(2, 'Zipcode must be at least 2 characters.')
    .max(7, 'Zipcode must be maximum 7 characters.'),
  number_of_rooms: yup
    .number()
    .typeError('Number of rooms must be a valid number.')
    .min(0, 'Number of rooms cannot be negative.')
    .max(1000000, 'Number of rooms is too large.')
    .nullable()
    .required('Number of rooms is required.')
    .test(
      'is-valid-decimal',
      'Number of rooms count must be a whole number or have up to 2 decimal places.',
      (value) => value === undefined || isValidDecimal.test(value.toString())
    ),
  number_of_bathroom: yup
    .number()
    .typeError('Number of bathrooms must be a valid number.')
    .min(0, 'Number of bathrooms cannot be negative.')
    .max(1000000, 'Number of bathrooms is too large')
    .nullable()
    .required('Number of bathrooms is required.')
    .test(
      'is-valid-decimal',
      'Number of bathrooms count must be a whole number or have up to 2 decimal places.',
      (value) => value === undefined || isValidDecimal.test(value.toString())
    ),
  square_foot: yup
    .number()
    .required('Square feet is required.')
    .typeError('Square feet must be a valid number.')
    .min(1, 'Square feet must be greater than 0.')
    .max(1000000, 'Square feet is too large.')
    .test(
      'is-valid-decimal',
      'Square feet count must be a whole number or have up to 2 decimal places.',
      (value) => value === undefined || isValidDecimal.test(value.toString())
    ),
  get_in: yup.string().trim().required('This field is required.'),
  get_in_instruction: yup
    .string()
    .trim()
    .required('Get-in instruction / door code is required.')
    .min(2, 'Get-in instruction / door code must be at least 2 characters.')
    .max(255, 'Get-in instruction / door code must be at most 255 characters long.'),
  laundry_code: yup.string().nullable().notRequired(),
  storage_area_code: yup.string().trim().nullable().notRequired(),
  propertyTasks: yup.array().of(
    yup.object().shape({
      task: yup
        .string()
        .trim()
        .transform((value, originalValue) => (originalValue === '' ? undefined : value))
        .notRequired()
        .min(2, 'Task must be at least 2 characters long.')
        .max(255, 'Task must be at most 255 characters long.')
      // .matches(
      //   /^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9.@\\&*, \\/\\_-]+(?<!\s)$/,
      //   'Task can only contain letters, numbers, spaces, and the symbols /\\.@-_,&* without leading or trailing spaces.'
      // )
    })
  ),
  propertyConsumables: yup.array().of(
    yup.object().shape({
      task: yup
        .string()
        .trim()
        .transform((value, originalValue) => (originalValue === '' ? undefined : value))
        .notRequired()
        .min(2, 'Item must be at least 2 characters long.')
        .max(255, 'Item must be at most 255 characters long.')
      // .matches(
      //   /^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9.@\\&*, \\/\\_-]+(?<!\s)$/,
      //   'Item can only contain letters, numbers, spaces, and the symbols /\\.@-_,&* without leading or trailing spaces.'
      // )
    })
  ),
  propertyICalLink: yup.array().of(
    yup.object().shape({
      ical_label: yup.string().test('label-required-if-link', 'ICAL label is required.', function (value) {
        const { ical_link } = this.parent
        return !ical_link || (ical_link && value)
      }),
      ical_link: yup
        .string()
        .test('link-required-if-label', 'ICAL link is required.', function (value) {
          const { ical_label } = this.parent
          return !ical_label || (ical_label && value)
        })
        .test('valid-url-if-present', 'ICAL link must be a valid URL.', function (value) {
          if (!value) return true // Don't validate if empty
          return yup.string().url().isValidSync(value)
        })
    })
  )
})

export const newRegionAdminSchema = yup.object().shape({
  admin_id: yup
    .object()
    .required('Admin is required.')
    .shape({
      admin_id: yup.string().required('Admin is required.'),
      first_name: yup
        .string()
        .required('First name is required.')
        .min(2, 'First name must be at least 2 characters long.')
        .max(50, 'First name must not be more than 50 characters.')
        .test('startWithCapital', 'First name must start with a capital letter.', (value) => startWithCapital.test(value))
        .test('noNumbers', 'First name should not contain numbers.', (value) => !digitRegx.test(value))
        .matches(NameRegx, 'First name can only contain letters without leading or trailing spaces.')
    }),
  region: yup.object().shape({
    region_id: yup.string().required('Region is required.')
  })
})

export const newRegionSchema = yup.object().shape({
  region: yup
    .string()
    .required('Region is required.')
    .min(2, 'Region must be at least 2 characters.')
    .nullable()
    .matches(regionNameRegx, 'Region can only contain letters without leading or trailing spaces.')
})

export const newAdminSchema = yup.object().shape({
  admin_id: yup
    .object()
    .required('Admin is required.')
    .shape({
      admin_id: yup.string().required('Admin is required.'),
      first_name: yup
        .string()
        .required('First name is required.')
        .min(2, 'First name must be at least 2 characters long.')
        .max(50, 'First name must not be more than 50 characters.')
        .test('startWithCapital', 'First name must start with a capital letter.', (value) => startWithCapital.test(value))
        .test('noNumbers', 'First name should not contain numbers.', (value) => !digitRegx.test(value))
        .matches(NameRegx, 'First name can only contain letters without leading or trailing spaces.')
    }),
  region: yup
    .object()
    .required('Region is required.')
    .shape({
      region_id: yup.string().required('Region is required.'),
      region: yup.string().required()
    })
})

export const newCitySchema = yup.object().shape({
  country: yup.string().required('Country is required.').trim().matches(OnlyAlphabet, 'Country can only contain letters.'),
  state: yup.string().required('State is required.').trim().matches(OnlyAlphabet, 'State can only contain letters.'),
  city: yup.string().required('City is required.').trim().matches(OnlyAlphabet, 'City can only contain letters.'),
  region: yup
    .object()
    .required('Region is required.')
    .shape({
      region_id: yup.string().required('Region is required.'),
      region: yup.string().required()
    })
})

// Define the schema
export const totalValueSchema = yup.object().shape({
  total_value: yup
    .number()
    .required('Total value is required.')
    .positive('Total value must be a positive number.')
    .typeError('Total value must be a valid number.')
})

export const cleanerServiceValueSchema = yup.object().shape({
  cleaner_service_value: yup
    .number()
    .typeError('Cleaner service value is required.')
    .required('Cleaner service value is required.')
    .min(0, 'Cleaner service value must not be negative.')
    .moreThan(0, 'Cleaner service value must be greater than 0.')
})

export const mainCleanerSchema = yup.object().shape({
  cleaners_id: yup
    .object()
    .nullable()
    .required('Main cleaner is required.') // Validation message
    .shape({
      cleaners_id: yup.string().required()
    })
})

export const addPaymentSchema = yup.object().shape({
  service_amount: yup
    .number()
    .typeError('Service value must be a number.')
    .required('Service value is required.')
    .positive('Service value must be positive.'),
  reason: yup.string().required('Reason is required.').min(3, 'Reason must be at least 3 characters long.')
})

export const addPhotosschema = yup.object().shape({
  cleaning_reports_category_id: yup.object().required('Type is required'),
  images: yup.array().min(1, 'At least 1 images is required')
})

export const addDocumentSchema = yup.object().shape({
  images: yup.array().min(1, 'At least 1 images is required')
})

export const couponSchema = yup.object().shape({
  name: yup
    .string()
    .required('Coupon name is required.')
    .max(50, 'Coupon name must not be more than 50 characters.')
    .matches(couponRegx, 'Coupon name must start with a letter and can contain letters, numbers, spaces, or symbols.'),
  discount: yup
    .number()
    .transform((value, originalValue) => (originalValue?.toString().trim().match(digitIsRegx) ? value : null))

    .required('Discount is required.')
    .positive('Discount must be a positive number.')
    .when('coupon_type', (couponType, schema) => {
      if (couponType[0] === 'flat') {
        return schema.test('fixedPrice-length', 'Discount must be at most 5 digits.', (value) => value === undefined || value.toString().length <= 5)
      }
      if (couponType[0] === 'percentage') {
        return schema.required('Discount is required').min(1, 'Discount must be between 1 and 99.').max(99, 'Discount must be between 1 and 99.')
      }
    }),
  amount_limit: yup
    .number()
    .transform((value, originalValue) => {
      return originalValue ? (originalValue?.toString().trim() ? value : null) : null
    })
    .required('Amount limit is required.')
    .integer('Amount limit must be a positive number.')
    .positive('Amount limit must be a positive number.')
    .test('max-digits', 'Amount limit can have at most 5 digits.', (value) => {
      if (value === undefined || value === null) {
        return true
      }
      const valueStr = value.toFixed(0)
      return valueStr.length <= 5
    }),

  code: yup
    .string()
    .required('Code is required.')
    .min(5, 'Code must be at least 5 characters long.')
    .max(15, 'Code must not be exceed 15 characters.')
    .matches(
      couponCodeRegx,
      'Code must start with an uppercase letter and can only contain uppercase letters, digits, dashes (-), or underscores (_).'
    ),
  application_from_date: yup.string().required('Start Date is required'),
  application_till_date: yup
    .string()
    .required('End Date is required')
    .test('application_till_date', 'End date must be after the start date.', (value, context) => {
      const application_from_date = context.parent.application_from_date
      if (!application_from_date) return false
      const selectedDate = new Date(application_from_date)
      const currentDate = new Date(value)
      return selectedDate < currentDate
    }),
  max_uses: yup
    .number()
    .transform((value, originalValue) => (originalValue?.toString().trim().match(digitIsRegx) ? value : null))
    .required('Max users is required.')
    .positive('Max users must be a positive number.')
    .test('max-digits', 'Max users can have at most 5 digits.', (value) => {
      return value === undefined || value.toString().length <= 5
    })
})

export const emailSchema = yup.object().shape({
  subject: yup
    .string()
    .required('Subject is required.')
    .min(5, 'Subject must be at least 5 characters.')
    .max(255, 'Subject cannot be more than 255 characters.')
    .matches(subjectStartRegx, 'Subject must start with a letter.')
    .matches(
      subjectRegx,
      'Subject must be start with a lettercan only contain letters, numbers, spaces, and the symbols /\\.@-_,&* without leading or trailing spaces.'
    )
    .nullable(),
  body: yup.string().required('Message is required.').min(2, 'Message must be at least 2 characters.').nullable()
})

export const sendEmailSchema = yup.object().shape({
  subject: yup
    .object()
    .transform((value) => (typeof value === 'string' ? {} : value))
    .required('Subject is required.'),
  body: yup.string().required('Message is required.').min(2, 'Message must be at least 2 characters.').nullable(),
  sendingTo: yup.array().min(1, 'At least one person select.').required('Person is required.')
})

export const pushNotificationSchema = yup.object().shape({
  subject: yup.object().required('Subject is required.'),
  body: yup.string().required('Message is required.').min(2, 'Message must be at least 2 characters.').nullable(),
  sendingTo: yup.array().min(1, 'At least one person select.').required('Person is required.')
})

export const clientFilterSchema = yup.object().shape({
  name: yup.string().nullable().matches(clientNameRegx, 'Host name can only contain letters.'),
  created_start: yup
    .string()
    .nullable()
    .transform((value) => (value === '' ? null : value)) // Convert empty string to null
    .test('start-before-end', 'Start date should be less than end date.', function (value) {
      const { created_end } = this.parent
      if (!value || !created_end) return true // Skip validation if either value is empty
      return new Date(value) <= new Date(created_end)
    }),
  created_end: yup
    .string()
    .nullable()
    .transform((value) => (value === '' ? null : value)) // Convert empty string to null
    .test('end-after-start', 'End date should be greater than start date.', function (value) {
      const { created_start } = this.parent
      if (!value || !created_start) return true // Skip validation if either value is empty
      return new Date(value) >= new Date(created_start)
    })
})

export const completCleanningSchema = yup.object().shape({
  started_cleaning_at: yup
    .string()
    .required('Cleaning start date and time is required.')
    .test('is-future-date', 'Cleaning start date and time are in the correct format and set to a future date.', (value) => {
      if (!value) return false
      const selectedDate = new Date(value)
      const currentDate = new Date()
      return selectedDate > currentDate
    }),
  ended_cleaning_at: yup
    .string()
    .required('Cleaning end date and time is required.')
    .test('is-future-date', 'Cleaning end date and time are in the correct format and set to a future date.', (value) => {
      if (!value) return false
      const selectedDate = new Date(value)
      const currentDate = new Date()
      return selectedDate > currentDate
    })
    .test('is-compare-with-cleaningStart', 'Cleaning end Date must be greater than the Cleaning Start date.', (value, context) => {
      const startedCleaningAt = context.parent.started_cleaning_at
      if (!startedCleaningAt) return false
      const selectedDate = new Date(startedCleaningAt)
      const currentDate = new Date(value)
      return selectedDate < currentDate
    }),
  cleaning_images: yup.array().min(1, 'At least 1 cleaning image is required.'),
  reports: yup.array().of(
    yup.object().shape({
      cleaning_reports_category: yup.lazy((value, { parent }) =>
        parent.title || parent.description || parent.cleaning_reports_category
          ? yup
              .object()
              .shape({
                cleaning_reports_category_id: yup.string().required('Category is required.'),
                category: yup.string().required('Category is required.')
              })
              .required('Category is required.')
          : yup.object().nullable().notRequired()
      ),
      title: yup.lazy((value, { parent }) => {
        if (parent.cleaning_reports_category || parent.description || parent.title) {
          return yup
            .string()
            .required('Issue name is required.')
            .min(2, 'Issue name must be at least 2 characters long.')
            .max(255, 'Issue name must be at most 255 characters long.')
            .matches(NameOnlyContainLetterRegx, 'Issue name can only contain letters without leading or trailing spaces.')
        }
        return yup.string().nullable().notRequired()
      }),
      description: yup.lazy((value, { parent }) => {
        if (parent.title || parent.cleaning_reports_category || parent.description) {
          return yup
            .string()
            .required('Describe issue is required')
            .min(2, 'Describe issue must be at least 2 characters long.')
            .max(255, 'Describe issue must be at most 255 characters long.')
            .matches(describeIssueRegx, 'Describe issue should not contain multiple consecutive spaces or newlines.')
        }
        return yup.string().nullable().notRequired()
      })
    })
  )
})

export const cleanerReportCategorySchema = yup.object().shape({
  category: yup
    .string()
    .required('Category is required.')
    .min(3, 'Category must be at least 3 characters.')
    .max(50, 'Category must not be exceed 50 characters.')
    .matches(categoryRegx, 'Category must include letters and can only contain alphanumeric characters.')
})

export const pricingTableSchema = yup.object({
  name: yup
    .string()
    .required('Title is required.')
    .max(50, 'Title can not be more than 50 characters.')
    .matches(pricingNameRegx, 'Title can only contain letters, numbers, spaces, and the symbols /\\.@-_,&* without leading or trailing spaces.'),
  region_id: yup.object().when('is_default', {
    is: (value) => !value,
    then: () =>
      yup
        .object()
        .shape({
          region_id: yup.string().required('Region is required.'),
          region: yup.string().required('Region is required.')
        })
        .required('Region is required.'),
    otherwise: () => yup.array().nullable().notRequired()
  }),
  service_id: yup
    .object()
    .shape({
      service_id: yup.string().required('Service is required.'),
      service: yup.string().required('Service is required.')
    })
    .required('Service is required.'),
  serviceName: yup
    .mixed()
    .test('string-or-object', 'Service can only contain letters and without leading or trailing spaces.', (value) => {
      if (!value) {
        return true
      }
      if (typeof value === 'string') {
        return serviceNameRegx.test(value)
      }
      if (typeof value === 'object' && value !== null) {
        return typeof value.service === 'string' && serviceNameRegx.test(value.service)
      }
      return false
    })
    .nullable(),
  pricing_type: yup.string().required('Pricing Type is required.'),

  pricingTableDetails: yup
    .array()
    .of(
      yup.object().shape({
        bedroom: yup
          .number()
          .typeError('Bedroom must be a valid number.')
          .min(0, 'Bedroom must not be negative.')
          .max(1000000, 'Bedroom is too large.')
          .nullable()
          .required('Bedroom is required.')
          .test(
            'is-valid-decimal',
            'Bedroom count must be a whole number or have up to 2 decimal places.',
            (value) => value === undefined || isValidDecimal.test(value.toString())
          ),
        bathroom: yup
          .number()
          .typeError('Bathroom must be a valid number.')
          .min(0, 'Bathroom must not be negative.')
          .max(1000000, 'Bathroom is too large.')
          .nullable()
          .required('Bathroom is required.')
          .test(
            'is-valid-decimal',
            'Bathroom count must be a whole number or have up to 2 decimal places.',
            (value) => value === undefined || isValidDecimal.test(value.toString())
          ),
        square_feet: yup
          .number()
          .required('Square feet is required.')
          .typeError('Square feet must be a valid number.')
          .min(1, 'Square feet must be greater than 0.')
          .max(1000000, 'Square feet is too large.')
          .test(
            'is-valid-decimal',
            'Square feet count must be a whole number or have up to 2 decimal places.',
            (value) => value === undefined || isValidDecimal.test(value.toString())
          ),
        price: yup
          .number()
          .typeError('Price must be a valid number.')
          .required('Price is required.')
          .test('is-valid-number', 'Price must be a valid number.', (value) => {
            return value !== undefined && value !== null && !isNaN(value)
          })
          .integer('Only whole numbers are allowed.')
          .min(1, 'Price must be greater than 0.')
          .max(100000000, 'Price is too large.'),
        exceed_price: yup
          .number()
          .typeError('Exceed Pprice must be a valid number.')
          .required('Exceed price is required.')
          .test('is-valid-number', 'Exceed price must be a valid number.', (value) => {
            return value !== undefined && value !== null && !isNaN(value)
          })
          .integer('Only whole numbers are allowed.')
          .min(0, 'Exceed price must be greater than 0.')
          .max(100000000, 'Exceed price is too large'),
        cleaner_payout: yup
          .number()
          .typeError('Cleaner payout must be a number.')
          .required('Cleaner payout is required.')
          .integer('Only whole numbers are allowed.')
          .min(1, 'Cleaner payout must be 1 to 100%.')
          .max(100, 'Cleaner payout must be 0 to 100%.'),
        avg_time: yup
          .number()
          .typeError('Avg time must be a number.')
          .required('Avg time is required.')
          .min(1, 'Avg time must be at least 1 hour.')
          .max(24, 'Avg time cannot exceed 24 hours.')
          .test(
            'is-valid-decimal',
            'Avg time count must be a whole number or have up to 2 decimal places.',
            (value) => value === undefined || isValidDecimal.test(value.toString())
          )
      })
    )
    .min(1, 'At least one row is required in the pricing table.')
    .required('Pricing table details are required.')
})
export const filterValidationSchema = yup.object().shape({
  created_start: yup
    .string()
    .nullable()
    .transform((value) => (value === '' ? null : value)) // Convert empty string to null
    .test('start-before-end', 'Start date should be less than end date.', function (value) {
      const { created_end } = this.parent
      if (!value || !created_end) return true // Skip validation if either value is empty
      return new Date(value) <= new Date(created_end)
    }),
  created_end: yup
    .string()
    .nullable()
    .transform((value) => (value === '' ? null : value)) // Convert empty string to null
    .test('end-after-start', 'End date should be greater than start date.', function (value) {
      const { created_start } = this.parent
      if (!value || !created_start) return true // Skip validation if either value is empty
      return new Date(value) >= new Date(created_start)
    })
})

export const editScheduleClening = yup.object().shape({
  booking_date_time: yup.string().required('Next checkin time is required.')
})
